import { createSelector } from "reselect";
import { getPersonalLoansCalculator } from "./index";

export const getScrolling = createSelector(
    getPersonalLoansCalculator,
    personalLoans => personalLoans.scrolling
);

export const getScrollToClass = createSelector(
    getScrolling,
    scrolling => scrolling.scrollToClass,
)

export const getScrollToId = createSelector(
    getScrolling,
    scrolling => scrolling.scrollToId,
)